import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Snow,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const SnowEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Snow),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type SnowEntity = InferOutput<typeof SnowEntitySchema>

/**
 * Frozen precipitation covering the ground, creating a cold and potentially difficult terrain for movement.
 */
export const SnowEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Snow,
  dname: 'Snow',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 1,
  entDefaults,
}

export function createSnowEntity(id: number, x: number, y: number): SnowEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
